(ns manage.adset-decision-tree-page.auto-generate-trackers-ocp.hook
  (:require [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.form :as form]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.cm360-settings :as cm360.q]
            [manage.adset-decision-tree-page.editor.util :refer [build-decision-path]]
            [manage.adset-decision-tree-page.sub :as sub]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- trackers->placement-map [^js data]
  (reduce (fn [m {:keys [node-immutable-id ad-variant-uuid placement-name]}]
            (assoc-in m [(str node-immutable-id) (str ad-variant-uuid)] (or placement-name "")))
          {}
          (:nodes (->clj data))))

(defn- variant->cm360-row
  [{:keys [id immutable-id]}
   node-id->node-data
   placement-map
   {:keys [uuid content-id]}]
  {:id (str id "-" uuid)
   :node-immutable-id immutable-id
   :ad-variant-uuid uuid
   :decisionPath (build-decision-path node-id->node-data id)
   :adVariant content-id
   :placement-name (get-in placement-map [(str immutable-id) (str uuid)] "")})

(defhook use-table-controls []
  (let [url-context (use-subscribe [:url-context])
        decision-tree-id (use-subscribe [::sub/decision-tree-id])
        node-id->node-data (use-subscribe [::sub/node-id->node-data])
        full-context (assoc url-context :decision-tree-id decision-tree-id)
        {trackers-data :data} (use-query
                               (js/Object.assign
                                (cm360.q/cm360-trackers-query full-context)
                                #js {:select trackers->placement-map}))
        initial-rows (uix/use-memo
                      (fn []
                        (clj->js (mapcat (fn [[_ node]]
                                           (map #(variant->cm360-row node
                                                                     node-id->node-data
                                                                     (or trackers-data {})
                                                                     %)
                                                (:ad-variants node)))
                                         node-id->node-data)))
                      [node-id->node-data trackers-data])
        [rows set-rows] (uix/use-state initial-rows)

        process-row-update (uix/use-callback
                            (fn [^js new-row ^js _old-row]
                              (set-rows (fn [^js current-rows]
                                          (.map current-rows
                                                (fn [^js row]
                                                  (if (= (.-id row) (.-id new-row))
                                                    new-row row)))))
                              new-row)
                            [])
        validate-placements (fn [] (every? #(not (str/blank? (:placement-name %))) (->clj rows)))]
    (uix/use-effect (fn [] (set-rows initial-rows)) [initial-rows])
    {:rows rows
     :process-row-update process-row-update
     :validate-placements validate-placements}))

(defhook use-cm360-selection-controls []
  (let [url-context (use-subscribe [:url-context])
        {settings-data :data} (use-query (cm360.q/cm360-settings-query url-context))
        {campaigns :data campaigns-loading :isLoading}
        (use-query (cm360.q/cm360-campaigns-query url-context))
        {sites :data sites-loading :isLoading}
        (use-query (cm360.q/cm360-sites-query url-context))
        {:keys [handleSubmit control]} (form/use-form
                                        #js {:values (->js (or (->clj settings-data) {}))
                                             :resetOptions #js {:keepDirtyValues true}})]
    {:control control
     :handleSubmit handleSubmit
     :campaign-options campaigns
     :site-options sites
     :campaigns-loading campaigns-loading
     :sites-loading sites-loading}))

(defhook use-on-save [{:keys [rows validate-placements handleSubmit]}]
  (let [url-context (use-subscribe [:url-context])
        decision-tree-id (use-subscribe [::sub/decision-tree-id])
        full-context (assoc url-context :decision-tree-id decision-tree-id)
        {save-settings :mutate} (use-mutation (cm360.q/cm360-settings-mutation url-context))
        {save-tracker-data :mutate} (use-mutation (cm360.q/save-cm360-tracker-data-mutation full-context))
        on-saved (fn []
                   (rf/dispatch [:response-handler/handle-response
                                 {:type :success :message "CM360 tracker settings saved"}])
                   (rf/dispatch [:ocp/close]))
        on-submit (handleSubmit
                   (fn [^js values]
                     (when (validate-placements)
                       (let [{:keys [campaign-id site-id]} (->clj values)
                             tracker-data (mapv #(select-keys % [:node-immutable-id :ad-variant-uuid :placement-name])
                                                (->clj rows))
                             on-trackers-saved #(save-tracker-data tracker-data #js {:onSuccess on-saved})]
                         (save-settings {:enabled true
                                         :campaign-id campaign-id
                                         :site-id site-id}
                                        #js {:onSuccess on-trackers-saved})))))
        [submitted set-submitted] (uix/use-state false)]
    {:on-save (fn []
                (set-submitted true)
                (on-submit))
     :submitted submitted}))

(defhook use-ocp-controls []
  (let [{:keys [rows validate-placements] :as table-controls} (use-table-controls)
        {:keys [handleSubmit] :as selection-controls} (use-cm360-selection-controls)
        {:keys [on-save submitted]} (use-on-save {:rows rows
                                                  :validate-placements validate-placements
                                                  :handleSubmit handleSubmit})]
    {:table-controls table-controls
     :selection-controls selection-controls
     :on-save on-save
     :submitted submitted}))
